import $ from "cash-dom";
var validate = require("validate.js");
import { Validator } from './FormValidator';
import { serializeToObject } from "./helpers";
const axios = require('axios').default;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['accept'] = 'application/json';

export class ValidatorFactory {
  constructor(type : string, form : HTMLFormElement) {
    switch (type) {
      case "vin":
        return new VinValidator(form);
      case "availability-form":
        return new AvailabilityFormValidator(form);
      case "contact-seller-form":
        return new ContactSellerFormValidator(form);
      case "vin-search":
        return new VinValidator(form);
      case "seller-account-form":
        return new SellerAccountValidator(form);
      case "get-alerts-form":
        return new AlertsValidator(form);
      default:
        throw new Error("Validator not found");
    }
  }
}

class VinValidator extends Validator {
  onSuccess() {
    let flow = 'https://www.bumper.com/lp/8b3bc4/2/loading?';
    let formInputValue = $('#vin-input').val();
    localStorage.setItem('__amplify__searchData', JSON.stringify(
    {
      "data":{
         "vin":formInputValue
      },
      "expires":null
    }
    ));
    window.location.href = flow + "vin=" + VinValidator.encode(formInputValue.toString());
  }
  onError() {
  }
  onChangeEvent(hasError: boolean) {
  }
  getConstraints() {
    return {
      vin: {
        presence: {
          allowEmpty: false,
          message: "^VIN number can't be blank"
        },
        format: {
          pattern: "^[a-zA-Z0-9]*$",
          flags: "i",
          message: "^VIN only allows alphanumeric values"
        }
      }
    }
  }
}
class AvailabilityFormValidator extends Validator {
  onSuccess() {
    this.submitForm();
  }
  onError() {
  }
  onChangeEvent(hasError: boolean) {
  }
  submitForm() {
    const form = $(this.form);
    const submitButton = form.find('[type=submit]');
    const formErrorMessage = form.find('.form-error');
    const submitButtonText = submitButton.html();

    const formFields = serializeToObject(form);
    const url = window.location.href;
    submitButton.prop('disabled', true);
    submitButton.html('Checking...');
    formErrorMessage.addClass('is-hidden');
    axios.post(url, formFields)
      .then(res => {
        this.handleRememberMe();
        $('.check-availability-modal').addClass('is-hidden');
        $('.confirmation-modal').removeClass('is-hidden');
      })
      .catch(error => {
        console.error(error);
        if (error && error.response && error.response.status == 403) {
          formErrorMessage.removeClass('is-hidden');
          formErrorMessage.html('Your session has expired, please reload the page and try again.');
        }
      })
      .then(() => {
        submitButton.prop('disabled', false);
        submitButton.html(submitButtonText);
      });
  }
  handleRememberMe() {
    if ($('#remember-me').is(':checked')) {
      localStorage.name = $('#check-availability-form-name-input').val();
      localStorage.email = $('#check-availability-form-email-input').val();
      localStorage.phone = $('#check-availability-form-phone-input').val() ? $('#check-availability-form-phone-input').val() : '';
      localStorage.checkBoxValidation = $('#remember-me').val();
    } else {
      localStorage.clear();
      $('#remember-me').val('on');
    }
  }
  getConstraints() {
    return {
      name: {
        presence: {
          allowEmpty: false,
          message: "^Please enter a name"
        },
        format: {
          pattern: /^[A-Za-z]+([\ A-Za-z]+)*/,
          flags: "i",
          message: "^Please enter a valid name"
        }
      },
      email: {
        presence: {
          allowEmpty: false,
          message: "^Please enter a valid email"
        },
        format: {
          pattern: /^^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
          flags: "i",
          message: "^Please enter a valid email"
        }
      },
      phone: {
        presence: {
          allowempty: true,
        },
        format: {
          pattern: /^^([\s]+)?$|(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
          flags: "i",
          message: "^Please enter a valid phone number"
        }
      },
    }
  }
}
class ContactSellerFormValidator extends Validator {
  onSuccess() {
    this.submitForm();
  }
  onError() {
  }
  onChangeEvent(hasError: boolean) {
  }
  submitForm() {
    const form = $(this.form);
    const submitButton = form.find('[type=submit]');
    const formErrorMessage = form.find('.form-error');
    const submitButtonText = submitButton.html();

    const formData = serializeToObject(form);
    const url = window.location.href;
    submitButton.prop('disabled', true);
    submitButton.html('Processing...');
    formErrorMessage.addClass('is-hidden');
    axios.post(url, formData)
      .then(res => {
        $('.contact-seller-form form').addClass('is-hidden');
        $('.confirmation-message').removeClass('is-hidden');
      })
      .catch(error => {
        console.error(error);
        if (error && error.response && error.response.status == 403) {
          formErrorMessage.removeClass('is-hidden');
          formErrorMessage.html('Your session has expired, please reload the page and try again.');
        }
      })
      .then(() => {
        submitButton.prop('disabled', false);
        submitButton.html(submitButtonText);
      });
  }
  getConstraints() {
    return {
      name: {
        presence: {
          allowEmpty: false,
          message: "^Please enter a name"
        },
        format: {
          pattern: /^[A-Za-z]+([\ A-Za-z]+)*/,
          flags: "i",
          message: "^Please enter a valid name"
        }
      },
      email: {
        presence: {
          allowEmpty: false,
          message: "^Please enter a valid email"
        },
        format: {
          pattern: /^^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
          flags: "i",
          message: "^Please enter a valid email"
        }
      },
      phone: {
        presence: {
          allowempty: true,
        },
        format: {
          pattern: /^^([\s]+)?$|(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
          flags: "i",
          message: "^Please enter a valid phone number"
        }
      },
    }
  }
}

class AlertsValidator extends Validator {
  onSuccess() {
    this.submitForm();
  }
  onError() {
  }
  onChangeEvent(hasError: boolean) {
      const button = document.querySelector('.alerts-form button');
      if (button) {
          button.textContent = 'Get Alerts';
      }
  }
  submitForm() {
    const form = $(this.form);
    const formData: FormData = serializeToObject(form) as FormData;
  
    const leadUrl = "https://www.bumper.com/api/v5/leads.json?";
    const leadData = {
      "lead[email]": formData.email,
      "lead[report_type]": "vin_organic",
    };
  
    const leadQueryArr = [];
    Object.keys(leadData).forEach((key) => {
      leadQueryArr.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(leadData[key])}`
      );
    });
  
    fetch(leadUrl + leadQueryArr.join("&"), { method: "POST" })
    .then(response => {
        if (response.ok) {
            const button = document.querySelector('.alerts-form button');
            const input = document.querySelector('.alerts-form input[name="email"]') as HTMLInputElement;
            if (button) {
                button.textContent = 'Email sent!';
            }
            if (input) {
                input.value = '';
            }
        }
    });
  }
  getConstraints() {
    return {
      email: {
        presence: {
          allowEmpty: false,
          message: "^Please enter a valid email"
        },
        format: {
          pattern: /^^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
          flags: "i",
          message: "^Please enter a valid email"
        }
      },
    }
  }
}

interface FormData {
  name: string;
  lastName: string;
  email: string;
  password1: string;
  password2: string;
  disclaimerCheck: boolean;
}

class SellerAccountValidator extends Validator {
  onSuccess() {
    this.submitForm();
  }
  onError() {
  }
  onChangeEvent(hasError: boolean) {
  }
  submitForm() {
    const form = $(this.form);
  
    const formData: FormData = serializeToObject(form) as FormData;

    console.log(formData);
  
    document.getElementById("unmatched-passwords").classList.add("is-hidden");
    document.getElementById("disclaimer-error").classList.add("is-hidden");
  
    if (formData.password1 !== formData.password2) {
      document.getElementById("unmatched-passwords").classList.remove("is-hidden");
      return;
    }
    let isChecked = $('#tos-check').prop('checked');
    if (!isChecked) {
      document.getElementById("disclaimer-error").classList.remove("is-hidden");
      return;
    }
  }
  getConstraints() {
    return {
      name: {
        presence: {
          allowEmpty: false,
          message: "^Please enter a first name"
        },
        format: {
          pattern: /^[A-Za-z]+([\ A-Za-z]+)*/,
          flags: "i",
          message: "^Please enter a valid first name"
        }
      },
      lastName: {
        presence: {
          allowEmpty: false,
          message: "^Please enter a last name"
        },
        format: {
          pattern: /^[A-Za-z]+([\ A-Za-z]+)*/,
          flags: "i",
          message: "^Please enter a valid last name"
        }
      },
      email: {
        presence: {
          allowEmpty: false,
          message: "^Please enter a valid email"
        },
        format: {
          pattern: /^^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
          flags: "i",
          message: "^Please enter a valid email"
        }
      },
      password1: {
        presence: {
          allowEmpty: false,
          message: "^Please enter a password"
        },
        length: {
          minimum: 8,
          message: "^Your password must be at least 8 characters"
        }
      },
      password2: {
        presence: {
          allowEmpty: false,
          message: "^Please enter a password"
        },
        length: {
          minimum: 8,
          message: "^Your password must be at least 8 characters"
        }
      },
      disclaimerCheck: {
        presence: {
          allowEmpty: false,
          message: "^Please enter a valid email"
        },
      },
    }
  }
}
/**
 * Custom Validators
 */

validate.validators.atLeastOneLetter = function (value) {
  if (!/[a-z]+/i.test(value)) {
    return "Alphabetic characters required";
  }
};

validate.validators.notEmail = function (value) {
  if (
    /^[ a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[ a-zA-Z0-9](?:[ a-zA-Z0-9-]{0,61}[ a-zA-Z0-9])?(?:\.[ a-zA-Z0-9](?:[ a-zA-Z0-9-]{0,61}[ a-zA-Z0-9])?)*$/.test(
      value
    )
  ) {
    return "Email addresses are not searchable here";
  }
};
